/**
 * AggregateRatingJsonLd — injects a Schema.org LocalBusiness + AggregateRating
 * JSON-LD <script> in the document head via react-helmet-async.
 *
 * Designed to be rendered on top-priority SEO pages (home, /avis-clients) so
 * Google can surface star snippets in the SERP based on REAL Google data.
 */
import { Helmet } from "react-helmet-async";

const SITE_URL = "https://www.mediastore79.com";

export const AggregateRatingJsonLd = ({ rating, total, googleMapsUrl }) => {
  if (!rating || !total) return null;
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "@id": `${SITE_URL}/#localbusiness`,
    name: "Mediastore Niort",
    url: SITE_URL,
    telephone: "+33549057490",
    image:
      "https://customer-assets.emergentagent.com/job_2010016e-c6ae-4f83-80db-30e5f9c887c1/artifacts/7vmwauk8_LOGO%20MEDIASTORE.JPG",
    address: {
      "@type": "PostalAddress",
      streetAddress: "104 Rue de la Gare",
      addressLocality: "Niort",
      postalCode: "79000",
      addressRegion: "Nouvelle-Aquitaine",
      addressCountry: "FR",
    },
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: rating.toFixed(1),
      reviewCount: String(total),
      bestRating: "5",
      worstRating: "1",
    },
    ...(googleMapsUrl ? { sameAs: [googleMapsUrl] } : {}),
  };
  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
    </Helmet>
  );
};

export default AggregateRatingJsonLd;
